<page-section sectionTitle="Past Projects" class="pt-4">
  <div class="container past-projects-container">
    <div *ngFor="let project of pastProjects" class="past-project">
      <a title="Link to {{project.name}} website" [href]="project.url">
        <img [src]="project.logoPath" alt="{{project.name + ' logo'}}">
      </a>
    </div>
  </div>
</page-section>
